import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoginRequestDto } from '../dtos/login-request.dto';
import { LoginResponseDto } from '../dtos/login-response.dto';
import { environment } from '../../../../environments/environment';
import { ResetPasswordRequestDto } from '../dtos/reset-password-request.dto';
import { RefreshTokenDto } from '../dtos/refresh-token.dto';
import { VerifyDto } from '../dtos/verify.dto';
import { RegisterAdminLegacyDto } from '../../admin/dtos/register-admin-legacy.dto';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  constructor(private http: HttpClient) {
  }

  login(loginDto: LoginRequestDto): Observable<LoginResponseDto> {
    return this.http.post<LoginResponseDto>(`${environment.cenplexBookingApiBaseUrl}/admins/login`, loginDto);
  }

  refresh(refreshTokenDto: RefreshTokenDto): Observable<LoginResponseDto> {
    return this.http.post<LoginResponseDto>(`${environment.cenplexBookingApiBaseUrl}/admins/refresh-token`, refreshTokenDto);
  }

  resetPassword(resetPasswordRequestDto: ResetPasswordRequestDto): Observable<void> {
    return this.http.post<void>(`${environment.cenplexBookingApiBaseUrl}/admins/reset-password`, resetPasswordRequestDto);
  }

  verify(verifyDto: VerifyDto): Observable<void> {
    return this.http.post<void>(`${environment.cenplexBookingApiBaseUrl}/admins/verify`, verifyDto);
  }
}
